function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "linkedin-[#161]",
    opacity: 0.54,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.999 20H15.999V13.001C15.999 11.081 15.152 10.0098 13.633 10.0098C11.98 10.0098 10.999 11.126 10.999 13.001V20H6.99902V7H10.999V8.46191C10.999 8.46191 12.254 6.25977 15.082 6.25977C17.911 6.25977 19.999 7.98611 19.999 11.5581V20ZM2.44102 4.9209C1.09202 4.9209 -0.000976562 3.81896 -0.000976562 2.45996C-0.000976562 1.10196 1.09202 0 2.44102 0C3.78902 0 4.88202 1.10196 4.88202 2.45996C4.88302 3.81896 3.78902 4.9209 2.44102 4.9209ZM-0.000976562 20H4.99902V7H-0.000976562V20Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLight);
export default __webpack_public_path__ + "static/media/linkedin_light.ef298880387389e0114b5915cc7c0a78.svg";
export { ForwardRef as ReactComponent };